import { render, staticRenderFns } from "./MultiFundHelpList.vue?vue&type=template&id=7efbd2a9&"
import script from "./MultiFundHelpList.vue?vue&type=script&lang=js&"
export * from "./MultiFundHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports